import { Button } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { setCreateModal } from '../../../app/deliverables/deliverablesSlice';
import { RootState } from '../../../app/store';
import { PageTitle } from '../../../components/StyledComponents';
import { isActionEnabled } from '../../utilities';
import { HeaderContainer } from '../StyledComponents';

const Header = () => {
  const dispatch = useDispatch();
  const allowedActions = useSelector((state: RootState) => state.deliverables.allowedActions);
  const canCreate = !!isActionEnabled(allowedActions, 'create-deliverable');

  const handleClick = () => {
    dispatch(setCreateModal({ isOpen: true}));
  };

  return (
    <HeaderContainer>
      <PageTitle>Deliverables</PageTitle>
      {canCreate && (
        <Button
          variant="contained"
          size="small"
          onClick={handleClick}
        >
          Create Deliverable
        </Button>
      )}

    </HeaderContainer>
  );
};

export { Header };
